module.exports = __webpack_public_path__ + "static/image-01-a@2x-45b0d4f6d626b978ce4caf645b682064.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/hudl/image-01-a@2x.jpg
// module id = 377
// module chunks = 3627797113349 20562973939449 33019919093843